import { ReactNode } from 'react';
import { CrossPartnerUserSettingsContext } from './context';
import { useCrossPartnerUserSettings } from './hooks/use-cross-partner-user-settings';

/**
 * fetches the user's cross-partner side-panel settings once, mounted above the
 * conversation-keyed subtree. Switching conversations remounts the personalization
 * provider; reading the already-resolved value from here (instead of the personalization
 * hook owning the query) keeps that remount from refetching and flashing the skeleton.
 */
export const CrossPartnerUserSettingsProvider = ({ children }: { children: ReactNode }) => {
  const value = useCrossPartnerUserSettings();

  return (
    <CrossPartnerUserSettingsContext.Provider value={value}>
      {children}
    </CrossPartnerUserSettingsContext.Provider>
  );
};
